import clsx from 'clsx'
import React from 'react'
import { useEnvironment } from '@hooks/useEnvironment'
import { SVGIcon, svgIconExists } from '../svg-icon/SVGIcon'
import { LoaderIcon } from '../svg-icon/types/SVGIcon.types'
import styles from './styles/Loader.module.scss'

type LoaderProps = {
  variant?: 'light' | 'dark'
  open?: boolean // default is true
  size?: 'default' | 'large' | 'extra-large'
  className?: string
}

/**
 * Simple loader with brand specific svg support
 */
export const Loader: React.FC<LoaderProps> = props => {
  const { open = true, size, variant = 'light', className } = props
  const { brand } = useEnvironment()

  let svgIconName: string | undefined = `loader-${brand}-${variant}`
  if (!svgIconExists(svgIconName)) {
    const fallbackName = `loader-base-${variant}`
    svgIconName = svgIconExists(fallbackName) ? fallbackName : undefined
  }

  return (
    <span
      className={clsx(
        svgIconName ? styles.svgLoader : styles.loader,
        styles[variant],
        open && styles.open,
        size && styles[size],
        className
      )}
    >
      {svgIconName && <SVGIcon library="loaders" name={svgIconName as LoaderIcon} />}
    </span>
  )
}

interface LoaderWithBackdropProps {
  loaderVariant?: LoaderProps['variant']
  open?: boolean // defaults to false
  backdropOnly?: boolean
}

/**
 * Loader with backdrop to block input
 */
export const LoaderWithBackdrop: React.FC<LoaderWithBackdropProps> = props => {
  const { open, loaderVariant, backdropOnly } = props

  return (
    <div className={clsx(styles.backdrop, open && styles.open)}>
      <Loader variant={loaderVariant} open={open && !backdropOnly} size="large" />
    </div>
  )
}

type GlasspaneProps = {
  open?: boolean // defaults to false
}

/**
 * Glasspane to block input
 */
export const Glasspane: React.FC<GlasspaneProps> = props => {
  const { open } = props

  return <div className={clsx(styles.backdrop, styles.glasspane, open && styles.open)}></div>
}
